import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
} from "@react-pdf/renderer";
import React from "react";
import ContractSummaryHeader from "./Header";
import Logo from "../../assets/images/Trust-telecom-New-Logo.png";
import FooterImage from "../../assets/images/pre-contract-summary-bottom-img.PNG";
import RobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import RobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";
import EmailIcon from "../../assets/icons/email-icon-new.png";
import LocationIcon from "../../assets/icons/navigation-icon.PNG";
import CallIcon from "../../assets/icons/call-icon.PNG";
import ContractPdfTable from "./Table";
import {
  calculateEarlyTerminationCharge,
  calculateUpgradeCharge,
  calcultePackageAmount,
  checkIfPaygExists,
  checkIncludeDateFairUsage,
  checkPlatformUpradeSelected,
  contractTerm,
  formatToTwoDecimals,
  getDataFairUsagePackagesName,
  renderAdditionalServiceForContractPdf,
  renderDiscountValidMonthsText,
  renderKeyPairsRowsForContractPdf,
} from "../../utils/helper";

// ✅ Correct way to register fonts with different weights
Font.register({
  family: "Roboto",
  fonts: [
    { src: RobotoLight, fontWeight: "light" },
    { src: RobotoBold, fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingBottom: 50,
  },
  footer: {
    position: "absolute",
    fontSize: 12,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
    paddingHorizontal: 15,
  },
  headerContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  logoContainer: {
    width: 120,
  },
  companyDetails: {
    textAlign: "center",
  },
  companyDetailsText: {
    fontSize: 11,
    fontFamily: "Roboto",
    fontWeight: "light",
    textAlign: "center",
  },
  titleContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: "20px",
  },

  title: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    marginBottom: "2px",
    borderBottom: "2px solid black",
  },

  text: {
    fontFamily: "Roboto",
    fontWeight: "light",
    fontSize: 12,
  },

  connectionContainer: {
    alignItems: "flex-end",
    marginTop: 30,
    // paddingRight: 10,
  },

  connectionRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    marginBottom: 5,
  },
  connectionText: {
    fontSize: 12,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  cellRow: {
    flexDirection: "row",
    borderBottom: "2px solid #c3c1c1",
  },
  cell: {
    width: "50%",
    padding: 6,
    fontSize: 11,
    fontWeight: "light",
  },
});

const ContractSummaryPDF = ({
  generalInfo,
  cliData,
  downloadSpeed,
  uploadSpeed,
  routerValue,
  cordedPhone,
  cordedlessPhone,
  equipments,
  isReqDebitDetail,
  paperBillingPrice,
  calculateOneOfCost,
  calculateTotalRevenue,
  contractLength,
  discountDetails,
}) => {
  // Constants Conditions
  const totalPlateFormUpgradeCharge =
    calculateUpgradeCharge(cliData)?.salePrice;
  const isPlatformOptionSeleted = checkPlatformUpradeSelected(cliData);
  const isPaygExists = checkIfPaygExists(cliData);
  const totalOneOfCost = calculateOneOfCost();
  const totalRevenue = calculateTotalRevenue();

  const isDownloadSpeed = downloadSpeed.min > 0 && downloadSpeed.max;
  const isUploadSpeed = uploadSpeed.min > 0 && uploadSpeed.max;

  const isIncludeDateFairUsageInLegacy = checkIncludeDateFairUsage(
    cliData,
    "legacyTariff",
    "legacy",
  );

  const isIncludeDateFairUsageInNgn = checkIncludeDateFairUsage(
    cliData,
    "digitalTariff",
    "ngnValue",
  );

  const dataFairUsagePackagesName = getDataFairUsagePackagesName(cliData);

  const renderTableDetailsForLegacy = (arg, bossIndex) => {
    const services = [
      arg?.lineValues[0]?.legacyService1,
      arg?.lineValues[0]?.legacyService2,
      arg?.lineValues[0]?.legacyService3,
      arg?.lineValues[0]?.legacyService4,
    ];

    const returnAkDamFinalPrice = () => {
      let finalPrice = Number(calcultePackageAmount(arg));

      if (bossIndex === 0 && routerValue.costType === "monthly") {
        finalPrice += Number(routerValue.price);
      }
      if (bossIndex === 0 && cordedPhone.costType === "monthly") {
        finalPrice += Number(cordedPhone.price);
      }
      if (bossIndex === 0 && cordedlessPhone.costType === "monthly") {
        finalPrice += Number(cordedlessPhone.price);
      }
      if (
        bossIndex === 0 &&
        equipments.costType === "monthly" &&
        equipments.value.trim() !== ""
      ) {
        finalPrice += Number(equipments.price);
      }

      return formatToTwoDecimals(finalPrice);
    };

    const isRouterIncluded =
      routerValue.value > 0 &&
      routerValue.costType === "monthly" &&
      bossIndex === 0;

    return arg?.lineValues.slice(0, 1).map((item, index) => {
      let attachment = structuredClone(item.legacy.other);

      if (isRouterIncluded && attachment["Router"]) {
        delete attachment["Router"];
      } else {
        attachment = attachment;
      }

      return (
        <React.Fragment key={index}>
          {renderKeyPairsRowsForContractPdf(attachment, isRouterIncluded)}
          {/* {renderSogeaCharges(arg.upgradeCharge)} */}
          <View style={styles.cellRow}>
            <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
              Contract Term
            </Text>
            <Text style={{ ...styles.cell, textAlign: "center" }}>
              {/* {contractLength?.title} */}
              {contractTerm(contractLength)}
            </Text>
          </View>

          {bossIndex === 0 &&
            routerValue.value > 0 &&
            routerValue.costType === "monthly" && (
              <View style={styles.cellRow}>
                <Text
                  style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
                >
                  Router – Configuration, Postage & Packaging
                </Text>
                <Text style={{ ...styles.cell, textAlign: "center" }}>
                  Included
                </Text>
              </View>
            )}

          {bossIndex === 0 &&
            cordedPhone.value > 0 &&
            cordedPhone.costType === "monthly" && (
              <View style={styles.cellRow}>
                <Text
                  style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
                >
                  Corded Phone - Configuration, Postage & Packaging
                </Text>
                <Text style={{ ...styles.cell, textAlign: "center" }}>
                  Included
                </Text>
              </View>
            )}

          {bossIndex === 0 &&
            cordedlessPhone.value > 0 &&
            cordedlessPhone.costType === "monthly" && (
              <View style={styles.cellRow}>
                <Text
                  style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
                >
                  Cordless Phone - Configuration, Postage & Packaging
                </Text>
                <Text style={{ ...styles.cell, textAlign: "center" }}>
                  Included
                </Text>
              </View>
            )}

          {bossIndex === 0 &&
            equipments.value?.trim() !== "" &&
            equipments.costType === "monthly" && (
              <View style={styles.cellRow}>
                <Text
                  style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
                >
                  {equipments?.name || equipments.value}
                </Text>
                <Text style={{ ...styles.cell, textAlign: "center" }}>
                  Included
                </Text>
              </View>
            )}

          <View style={styles.cellRow}>
            <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
              Tariff Rental{" "}
              {discountDetails
                ? renderDiscountValidMonthsText(discountDetails)
                : ""}
            </Text>
            <Text style={{ ...styles.cell, textAlign: "center" }}>
              £{returnAkDamFinalPrice()} per month
            </Text>
          </View>

          {arg?.additionalService.isSelected &&
            renderAdditionalServiceForContractPdf(
              services,
              arg?.lineValues?.length,
            )}
        </React.Fragment>
      );
    });
  };

  const renderTableDetailsForNgN = (mainOption, arg, bossIndex, junIndex) => {
    const services = [
      arg?.ngnService1,
      arg?.ngnService2,
      arg?.ngnService3,
      arg?.ngnService4,
    ];

    const returnFullAndFinalPrice = () => {
      let finalPrice = arg.ngnValue.salePrice;
      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        routerValue.costType === "monthly"
      ) {
        finalPrice += Number(routerValue.price);

        // Number(cordedlessPhone.price);
      }
      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        cordedPhone.costType === "monthly"
      ) {
        finalPrice += Number(cordedPhone.price);
      }

      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        cordedlessPhone.costType === "monthly"
      ) {
        finalPrice += Number(cordedlessPhone.price);
      }

      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        equipments.costType === "monthly" &&
        equipments?.value?.trim() !== ""
      ) {
        finalPrice += Number(equipments.price);
      }

      // Round to two decimal places
      return formatToTwoDecimals(finalPrice);
    };

    const isRouterIncluded =
      routerValue.value > 0 &&
      routerValue.costType === "monthly" &&
      bossIndex === 0 &&
      junIndex === 0;

    let attachment = structuredClone(arg?.ngnValue?.other);

    if (isRouterIncluded && attachment["Router"]) {
      delete attachment["Router"];
    } else if (isRouterIncluded && attachment["Router and Handset"]) {
      delete attachment["Router and Handset"];
    } else {
      attachment = attachment;
    }

    return (
      <React.Fragment>
        {renderKeyPairsRowsForContractPdf(attachment)}
        {/* {renderSogeaCharges(mainOption.upgradeCharge)} */}

        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            Contract Term
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            {/* {contractLength?.title} */}
            {contractTerm(contractLength)}
          </Text>
        </View>

        {bossIndex === 0 &&
          junIndex === 0 &&
          routerValue.value > 0 &&
          routerValue.costType === "monthly" && (
            <View style={styles.cellRow}>
              <Text
                style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
              >
                Router – Configuration, Postage & Packaging
              </Text>
              <Text style={{ ...styles.cell, textAlign: "center" }}>
                Included
              </Text>
            </View>
          )}

        {bossIndex === 0 &&
          junIndex === 0 &&
          cordedPhone.value > 0 &&
          cordedPhone.costType === "monthly" && (
            <View style={styles.cellRow}>
              <Text
                style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
              >
                Corded Phone - Configuration, Postage & Packaging
              </Text>
              <Text style={{ ...styles.cell, textAlign: "center" }}>
                Included
              </Text>
            </View>
          )}

        {bossIndex === 0 &&
          junIndex === 0 &&
          cordedlessPhone.value > 0 &&
          cordedlessPhone.costType === "monthly" && (
            <View style={styles.cellRow}>
              <Text
                style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
              >
                Cordless Phone - Configuration, Postage & Packaging
              </Text>
              <Text style={{ ...styles.cell, textAlign: "center" }}>
                Included
              </Text>
            </View>
          )}

        {bossIndex === 0 &&
          junIndex === 0 &&
          equipments.value?.trim() !== "" &&
          equipments.costType === "monthly" && (
            <View style={styles.cellRow}>
              <Text
                style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
              >
                {equipments?.name || equipments.value}
              </Text>
              <Text style={{ ...styles.cell, textAlign: "center" }}>
                Included
              </Text>
            </View>
          )}

        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            Tariff Rental{" "}
            {discountDetails
              ? renderDiscountValidMonthsText(discountDetails)
              : ""}
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            £{returnFullAndFinalPrice()} per month
          </Text>
        </View>

        {mainOption.additionalService.isSelected &&
          renderAdditionalServiceForContractPdf(services, 0)}
      </React.Fragment>
    );
  };

  const renderSelectedService = () => {
    return cliData?.map((valll, mainIndex) => {
      if (
        valll?.legacyTariff?.isSelected === true &&
        valll?.lineValues[0]?.legacy?.value
      ) {
        let isIncludeDateFairUsage =
          valll?.lineValues[0]?.legacy?.includeDateFairUsage;
        let cliNumber = valll?.cliNumber ? valll?.mobileNo : "New Connection";
        let showHeader = `${cliNumber} ${"\u00A0\u00A0"} ${
          valll?.lineValues[0]?.legacy?.value
        } x ${valll?.lineValues?.length} ${isIncludeDateFairUsage ? "*" : ""}`;
        return (
          <ContractPdfTable
            key={mainIndex}
            primary={showHeader}
            secondary={"Details"}
            data={renderTableDetailsForLegacy(valll, mainIndex)}
          />
        );
      }
      if (valll?.digitalTariff?.isSelected === true) {
        return valll.lineValues?.map((itemm, index) => {
          let ngnValueName = itemm?.ngnValue?.value;
          let cliNumber = valll?.cliNumber ? valll?.mobileNo : "New Connection";
          let isIncludeDateFairUsage = itemm?.ngnValue?.includeDateFairUsage;
          if (ngnValueName) {
            return (
              <ContractPdfTable
                key={index}
                primary={`${cliNumber} ${"\u00A0\u00A0"} Line ${
                  index + 1
                } : ${ngnValueName} ${isIncludeDateFairUsage ? "*" : ""}`}
                secondary={"Details"}
                data={renderTableDetailsForNgN(valll, itemm, mainIndex, index)}
              />
            );
          }
        });
      }
    });
  };

  const secondTableData = [
    ...(routerValue?.value > 0 && routerValue.costType === "oneOfCost"
      ? [
          {
            feature: "Router – Configuration, Postage & Packaging",
            details: `£${formatToTwoDecimals(routerValue.price)}`,
          },
        ]
      : []),

    ...(cordedPhone?.value > 0 && cordedPhone.costType === "oneOfCost"
      ? [
          {
            feature: "Corded Phone - Configuration, Postage & Packaging",
            details: `£${formatToTwoDecimals(cordedPhone.price)}`,
          },
        ]
      : []),

    ...(cordedlessPhone?.value > 0 && cordedlessPhone.costType === "oneOfCost"
      ? [
          {
            feature: "Cordless Phone - Configuration, Postage & Packaging",
            details: `£${formatToTwoDecimals(cordedlessPhone.price)}`,
          },
        ]
      : []),

    ...(isPlatformOptionSeleted
      ? [
          {
            feature: "Platform Upgrade Fee",
            details: `£${formatToTwoDecimals(totalPlateFormUpgradeCharge)}`,
          },
        ]
      : []),

    ...(equipments?.value.trim() !== "" && equipments?.costType === "oneOfCost"
      ? [
          {
            feature: equipments?.name || equipments.value,
            details: `£${formatToTwoDecimals(equipments.price)}`,
          },
        ]
      : []),

    {
      feature: "Early Termination Charge",
      details: `£${calculateEarlyTerminationCharge(totalRevenue, contractLength)}`,
    },
  ];

  const thirdTableData = [
    { feature: "UK Landline Calls (01, 02, & 03)", details: "4p" },
    { feature: "Mobile Calls  (6 Major UK networks)", details: "16p" },
    {
      feature: "UK Landline Connection Charge",
      details: "18p",
    },
    {
      feature: "UK Mobile Connection Charge",
      details: "20p",
    },
  ];

  const fourthTableData = [
    ...(isDownloadSpeed
      ? [
          {
            feature: "Download",
            details: `${downloadSpeed.min} to ${downloadSpeed.max} Mbps`,
          },
        ]
      : []),
    ...(isUploadSpeed
      ? [
          {
            feature: "Upload",
            details: `${uploadSpeed.min} to ${uploadSpeed.max} Mbps`,
          },
        ]
      : []),
  ];

  const renderUploadAndDownload = () => {
    return fourthTableData.map((valll, index) => {
      return (
        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            {valll.feature}
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            {" "}
            {valll.details}
          </Text>
        </View>
      );
    });
  };

  const renderPaygValues = () => {
    return thirdTableData.map((valll, index) => {
      return (
        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            {valll.feature}
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            {" "}
            {valll.details}
          </Text>
        </View>
      );
    });
  };

  const renderInstallatuionDetails = () => {
    return secondTableData.map((valll, index) => {
      return (
        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            {valll.feature}
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            {" "}
            {valll.details}
          </Text>
        </View>
      );
    });
  };

  const renderAddHocServices = () => {
    if (isReqDebitDetail.no || generalInfo.eBilling == "No") {
      return (
        <>
          {generalInfo.eBilling == "No" && (
            <View style={styles.cellRow}>
              <Text
                style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
              >
                Paper Billing Charges
              </Text>
              <Text style={{ ...styles.cell, textAlign: "center" }}>
                £{paperBillingPrice.salePrice}
              </Text>
            </View>
          )}
          {isReqDebitDetail.no && (
            <View style={styles.cellRow}>
              <Text
                style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}
              >
                Payment Processing Fee
              </Text>
              <Text style={{ ...styles.cell, textAlign: "center" }}>£7</Text>
            </View>
          )}
        </>
      );
    }
  };

  const renderTotalCharges = () => {
    return (
      <>
        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            One-off Cost
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            £{formatToTwoDecimals(totalOneOfCost)}
          </Text>
        </View>
        <View style={styles.cellRow}>
          <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
            Monthly Cost{" "}
          </Text>
          <Text style={{ ...styles.cell, textAlign: "center" }}>
            £{formatToTwoDecimals(totalRevenue)}
          </Text>
        </View>
      </>
    );
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <ContractSummaryHeader>
          <View style={styles.headerContainer}>
            <View style={styles.logoContainer}>
              <Image src={Logo} style={{ width: "100%" }} />
            </View>

            <View style={styles.companyDetails}>
              <Text style={styles.companyDetailsText}>
                167-169 Great Portland Street,
              </Text>
              <Text style={styles.companyDetailsText}>
                5th Floor, London, England, W1W 5PF
              </Text>
              <Text style={styles.companyDetailsText}>
                Email: support@trust-business.co.uk
              </Text>
              <Text style={styles.companyDetailsText}>
                Support Number - 0207 629 9888{" "}
              </Text>
              <Text style={styles.companyDetailsText}>
                Company Number - 15994771{" "}
              </Text>
              <Text style={styles.companyDetailsText}>VAT no. 482386855 </Text>
            </View>
          </View>

          <View style={styles.titleContainer}>
            <Text style={styles.title}>Contract Summary</Text>
          </View>

          <Text style={styles.text}>
            Dear {`${generalInfo.title} ${generalInfo.name}`}
          </Text>
          <Text style={{ ...styles.text, marginTop: "10px" }}>
            Please find enclosed a detailed breakdown of your preferred tariff.
          </Text>

          <View style={{ marginTop: 20 }}>{renderSelectedService()}</View>

          <ContractPdfTable
            primary={"Hardware, Installation, Early Termination"}
            secondary={"One-off Costs"}
            data={renderInstallatuionDetails()}
          />

          {isPaygExists && (
            <ContractPdfTable
              primary={"PAYG Call Charges"}
              secondary={"Sale Price"}
              data={renderPaygValues()}
            />
          )}

          {(isDownloadSpeed || isUploadSpeed) && (
            <ContractPdfTable
              primary={"Internet Data"}
              secondary={"Speed Range"}
              data={renderUploadAndDownload()}
            />
          )}

          {(isReqDebitDetail.no || generalInfo.eBilling == "No") && (
            <ContractPdfTable
              primary={"Ad hoc Services/Charges"}
              secondary={"Sale Price"}
              data={renderAddHocServices()}
            />
          )}

          <ContractPdfTable
            primary={"Pricing Breakdown"}
            secondary={"Total Amount"}
            data={renderTotalCharges()}
          />

          <Text style={{ ...styles.text, marginTop: "10px" }}>
            Trust Business will not automatically renew your contract term or
            increase the cost of your tariff after the initial contract period.
            Your service will continue without interruption. You will be
            notified 30 days in advance of any future price increases and have
            the right to cancel without penalty during that period. All prices
            exclude VAT.
          </Text>

          <Text style={{ ...styles.text, marginTop: "10px" }}>
            {/* If there is a recurring and continuous discrepancy between actual and
        contracted internet performance, you are entitled to cancel free of
        charge.
         */}
            The Business Assurance and Care Level 2 package is automatically
            added from month three at a recurring charge of £5 per month per
            Premises unless the Customer opts out.
          </Text>
          <Text style={{ ...styles.text, marginTop: "10px" }}>
            If your Broadband Service regularly and continuously falls below the
            speed range shown above, as measured at the router rather than over
            Wi-Fi, you must report it and allow us a reasonable opportunity to
            investigate and fix it. If it cannot be fixed, you may cancel the
            affected Broadband Service without an Early Termination Charge, but
            no compensation or retrospective refund will be payable.{" "}
            {isIncludeDateFairUsageInLegacy || isIncludeDateFairUsageInNgn
              ? `${dataFairUsagePackagesName.join(", ")} is subject to a *fair usage policy of 400 GB per month. Data used outside of this allowance is charged at 3p per MB.`
              : ""}
          </Text>
          <Text style={{ ...styles.text, marginTop: "10px" }}>
            Find our Terms and Conditions, including complaints procedure,
            attached.
          </Text>

          <View style={styles.connectionContainer}>
            {/* Address */}
            <View style={styles.connectionRow}>
              <Text style={styles.connectionText}>
                167-169 Great Portland Street, 5th Floor, London, England, W1W
                5PF
              </Text>
              <View style={{ width: 10 }}>
                <Image src={LocationIcon} style={{ width: "100%" }} />
              </View>
            </View>

            {/* Phone */}
            <View style={styles.connectionRow}>
              <Text style={styles.connectionText}>0207 629 9888</Text>
              <View style={{ width: 11 }}>
                <Image src={CallIcon} style={{ width: "100%" }} />
              </View>
            </View>

            {/* Email */}
            <View style={styles.connectionRow}>
              <Text style={styles.connectionText}>
                support@trust-business.co.uk
              </Text>
              <View style={{ width: 12 }}>
                <Image src={EmailIcon} style={{ width: "100%" }} />
              </View>
            </View>
          </View>
        </ContractSummaryHeader>

        <View style={styles.footer} fixed>
          <Image src={FooterImage} style={{ width: "100%" }} />
        </View>
      </Page>
    </Document>
  );
};

export default ContractSummaryPDF;
